// Add Data to product data that potentially can/should be aded tp PIM and retrieved via Backend
import {colourMapping, displayStyleMapping, regionMapping} from '../augmentProductData';

export const augmentProductDataMiddleware = store => next => action => {
	if (action.type === 'productData/productDataLoading/fulfilled') {
		const mode = store.getState().status.mode;
		const family = store.getState().status.family;

		// add the color hax values depending on featureID /valueID
		action.payload.forEach(component => {

			component.features.forEach(feature => {

				if (feature.featureId === 'LE_LightDistribution_2') {
					// feature.isVisible = true;
				}

				// add displaystyle to features
				feature.displayStyle = displayStyleMapping[mode][feature.featureId] ?? 'listSelect';

				// add regional visibility to features and values
				feature.includeRegions = regionMapping[feature.featureId]?.includeRegions ?? null;
				feature.excludeRegions = regionMapping[feature.featureId]?.excludeRegions ?? null;

				feature.values.forEach(value => {
					value.displayColour = colourMapping[value.valueId] ?? '#0f0';
					value.includeRegions = regionMapping[feature.featureId]?.values[value.valueId]?.includeRegions ?? null;
					value.excludeRegions = regionMapping[feature.featureId]?.values[value.valueId]?.excludeRegions ?? null;
				});

				// add colorValues to FeatureValues
				switch (feature.featureId) {
					case 'HS_HousingColour':
					case 'LE_ReflectorColour_1':
					case 'LE_ReflectorColour_2':
						feature.values.forEach(value => {
							value.displayColour = colourMapping[value.valueId] ?? '#0f0';
						});
						break;
					case 'LE_DimmingLevel_1':
					case 'LE_LuminairePositionHeight_1':
					case 'LE_LuminairePositionHeight_2':
					case 'LE_LuminairePositionHeightSU_1':
					case 'LE_LuminairePositionHeightSU_2':
					case 'LU_SolarUnitHeight':
					case 'HS_HousingHeight':
						// debug, show feature
						feature.isVisible = true;
						break;
				}
			});
		});

	}
	return next(action);
};
